import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import ImportExcel from "../ImportExcel";
import Invoice from "./Invoice";
import Conflicts from "../Conflicts/Conflicts";

export default class Invoices extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'invoice',
            data: null,
            loading: true,
            id_to_remove: null,
            page: 1,
            per_page: 30,
            phrase: '',
            ids: [],
            filters: {
                status: 0,
                inp: 0,
                ins: 0,
                setm: 0,
                taxNumber: '',
                factorNo: ''
            },
            systemModuleId: 1,
            moduleAccessStatus: 1,
            menuId: 32,
            task: 0,
            currentConflictId: null,
            conflicts: []
        };
        if (!this.isBlank(this.getQueryString("factorno")))
            this.state.filters.factorNo = parseInt(this.getQueryString("factorno"));
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
                this.getConflicts();
            });
    }
    getConflicts() {
        this.httpPost("api/v1/conflict/list", {
            filters: {
                usage: 5
            }
        })
            .then(data => {
                if (data.status === 1) {
                    this.setState({ conflicts: data.records });
                }
            });
    }
    showConflicts() {
        this.showComponents({ component: <Conflicts Caller={this} Usage={5} /> });
    }
    saveChecked(entityRecordId, checked) {
        if (this.isBlank(this.state.currentConflictId)) return;
        var conflictId = this.state.currentConflictId;

        this.httpPost("api/v1/conflict/check", {
            usage: 5,
            conflictId,
            entityRecordId,
            checked
        }, false)
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });

        this.state.data.records.forEach(f => {
            if (f.id === entityRecordId) {
                var tempConflicts = [];
                f.conflicts.forEach(c => {
                    if (c !== conflictId) tempConflicts.push(c);
                });
                if (checked) tempConflicts.push(conflictId);
                f.conflicts = tempConflicts;
            }
        });

        this.setState({ data: this.state.data });
    }
    enqueue(id) {
        this.sendEnqueue([id]);
    }
    sendEnqueue(ids) {
        this.httpPost("api/v1/invoice/enqueue", {
            ids: ids,
            companyId: this.state.data.global.company.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("ارسال با موفقیت انجام پذیرفت گردید");
                    this.refreshData();
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    reference(id) {
        this.httpPost("api/v1/invoice/reference", {
            id: id,
            companyId: this.state.data.global.company.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("استعلام صورتحساب دریافت شد");
                    this.refreshData();
                    this.onEdit(id);
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    getToolBars(record) {
        var m = [];
        m.push(<li><NavLink to={"/invoice/view/" + record.id} title="مشاهده"><em className="icon ni ni-eye"></em> <span>مشاهده</span></NavLink></li>);
        if (record.status === 1 || record.status === 3 || record.sendToTax) {
            m.push(<li><a onClick={e => this.onEdit(record.id)} title="ویرایش"><em className="icon ni ni-pen"></em> <span>ویرایش</span></a></li>);
            m.push(<li><a className="hand" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف"><em className="icon ni ni-na"></em> <span>حذف صورتحساب</span></a></li>);
        }
        if (record.status === 1 || record.status === 3) {
            m.push(<li><a className="hand" onClick={e => this.enqueue(record.id)} title="ارسال به سامانه"><em className="icon ni ni-send"></em> <span>ارسال به سامانه</span></a></li>);
        }
        if (record.status === 2) {
            m.push(<li><a className="hand" onClick={e => this.reference(record.id)} title="استعلام"><em className="icon ni ni-search"></em> <span>استعلام صورتحساب</span></a></li>);
        }
        if (record.status === 4) {
            m.push(<li><a onClick={e => this.onAddCancell(record.id)} title="صدور ابطالی"><em className="icon ni ni-property-remove"></em> <span>صدور ابطالی</span></a></li>);
            m.push(<li><a onClick={e => this.onAddModify(record.id)} title="صدور اصلاحی"><em className="icon ni ni-property-add"></em> <span>صدور اصلاحی</span></a></li>);
            m.push(<li><a onClick={e => this.onAddReturn(record.id)} title="صدور برگشت از فروش"><em className="icon ni ni-property-alt"></em> <span>صدور برگشت از فروش</span></a></li>);
        }
        return m;
    }
    setChecked(e, id) {
        var t = [];
        this.state.Ids.forEach(i => {
            if (i != id) t.push(i);
        });
        if (e.target.checked) t.push(id);
        this.state.Ids = t;
    }
    onImport(type) {
        this.removeKeyDown();
        this.showComponents({ component: <ImportExcel Caller={this} Type={type} CompanyId={this.state.data.global.company.id} /> });
    }

    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Invoice Caller={this} Inp={1} Ins={1} IsNew={false} Id={id} /> });
    }
    onAdd(inp) {
        this.removeKeyDown();
        this.showComponents({ component: <Invoice Caller={this} Inp={inp} Ins={1} IsNew={true} /> });
    }
    onAddModify(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Invoice Caller={this} Inp={0} Ins={2} IsNew={true} Id={id} /> });
    }
    onAddCancell(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Invoice Caller={this} Inp={0} Ins={3} IsNew={true} Id={id} /> });
    }
    onAddReturn(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Invoice Caller={this} Inp={0} Ins={4} IsNew={true} Id={id} /> });
    }
    doTask(e) {
        this.httpPost("api/v1/invoice/task", {
            task: this.state.task,
            companyId: this.state.data.global.company.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage(data.taskResult);
                    this.refreshData();
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست صورتحسابهای فروش</h3>
                            <div className="nk-block-des text-soft">
                                <p>شما {this.money(this.state.data.recordsCount)} صورتحساب ثبت شده دارید</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li className="nk-block-tools-opt">
                                            <div className="drodown">
                                                <a href="#" className="dropdown-toggle btn btn-primary" data-bs-toggle="dropdown" aria-expanded="true">
                                                    ثبت صورتحساب جدید
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-end" data-popper-placement="bottom-end">
                                                    <ul className="link-list-opt no-bdr">
                                                        <li><a onClick={e => this.onAdd(1)}><span>فروش</span></a></li>
                                                        <li><a onClick={e => this.onAdd(2)}><span>فروش ارزی</span></a></li>
                                                        <li><a onClick={e => this.onAdd(3)}><span>طلا و جواهر و پلاتین</span></a></li>
                                                        <li><a onClick={e => this.onAdd(4)}><span>پیمانکاری</span></a></li>
                                                        <li><a onClick={e => this.onAdd(5)}><span>قبوض خدماتی</span></a></li>
                                                        <li><a onClick={e => this.onAdd(6)}><span>بلیت هواپیما</span></a></li>
                                                        <li><a onClick={e => this.onAdd(7)}><span>صادرات</span></a></li>
                                                        <li><a onClick={e => this.onAdd(8)}><span>بارنامه</span></a></li>
                                                        <li><a onClick={e => this.onAdd(13)}><span>فروش خدمات بیمه</span></a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                        {1 == 2 && <li className="nk-block-tools-opt">
                                            <div className="drodown">
                                                <a href="#" className="dropdown-toggle btn btn-success" data-bs-toggle="dropdown" aria-expanded="true">
                                                    ایمپورت اکسل</a>
                                                <div className="dropdown-menu dropdown-menu-end" data-popper-placement="bottom-end">
                                                    <ul className="link-list-opt no-bdr">
                                                        <li><a onClick={e => this.onImport(5)}><span>فروش</span></a></li>
                                                        <li><a onClick={e => this.onImport(6)}><span>فروش ارزی</span></a></li>
                                                        <li><a onClick={e => this.onImport(7)}><span>طلا و جواهر و پلاتین</span></a></li>
                                                        <li><a onClick={e => this.onImport(8)}><span>پیمانکاری</span></a></li>
                                                        <li><a onClick={e => this.onImport(9)}><span>قبوض خدماتی</span></a></li>
                                                        <li><a onClick={e => this.onImport(10)}><span>بلیت هواپیما</span></a></li>
                                                        <li><a onClick={e => this.onImport(11)}><span>صادرات</span></a></li>
                                                        <li><a onClick={e => this.onImport(12)}><span>بارنامه</span></a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>}
                                        <li>
                                            <a onClick={e => this.getPdfs(e)} className="btn btn-white btn-outline-light"><em className="icon ni ni-file-pdf"></em><span>خروجی PDF اطلاعات</span></a>
                                        </li>
                                        <li>
                                            <a onClick={e => this.refreshData(e, "list", "excel")} className="hand btn btn-success"><span>دانلود اکسل</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <div className="nk-block-des text-success"><p>مجموع: {this.money(this.state.data.totalInvoice)} {this.state.data.global.company.currencyUnit}</p></div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="nk-block-des text-warning"><p>مجموع فاکتورهای فروش: {this.money(this.state.data.totalFactor)} {this.state.data.global.company.currencyUnit}</p></div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="nk-block-des text-danger"><p>مغایرت با فروش: {this.money(this.state.data.totalFactor - this.state.data.totalInvoice)} {this.state.data.global.company.currencyUnit}</p></div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">

                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="طرف حساب" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.taxNumber} onChange={e => this.state.filters.taxNumber = e.target.value} placeholder="شماره مالیاتی" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.factorNo} onChange={e => this.state.filters.factorNo = parseInt(e.target.value)} placeholder="شماره فاکتور" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.status} onChange={e => this.state.filters.status = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">همه وضعیتها</option>
                                                    <option value="1">ارسال نشده</option>
                                                    <option value="2">ارسال شده بدون استعلام</option>
                                                    <option value="3">استعلام شده دارای خطا</option>
                                                    <option value="4">ارسال شده موفق</option>
                                                    <option value="5">ارسال شده موفق خارج از سیستم</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.inp} onChange={e => this.state.filters.inp = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">همه الگوهای</option>
                                                    <option value="1">فروش</option>
                                                    <option value="2">فروش ارزی</option>
                                                    <option value="3">طلا و جواهر و پلاتین</option>
                                                    <option value="4">پیمانکاری</option>
                                                    <option value="5">قبوض خدماتی</option>
                                                    <option value="6">بلیت هواپیما</option>
                                                    <option value="7">صادرات</option>
                                                    <option value="8">بارنامه</option>
                                                    <option value="13">فروش خدمات بیمه</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.ins} onChange={e => this.state.filters.ins = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">همه موضوعات</option>
                                                    <option value="1">اصلی</option>
                                                    <option value="2">اصلاحی</option>
                                                    <option value="3">ابطالی</option>
                                                    <option value="4">برگشت از فروش</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.setm} onChange={e => this.state.filters.setm = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">همه روشهای تسویه</option>
                                                    <option value="1">نقدی</option>
                                                    <option value="2">نسیه</option>
                                                    <option value="3">نقد/نسیه</option>
                                                </select>
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em className="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <div className="card-tools">
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.task} onChange={e => this.state.task = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">عملیات دسته جمعی</option>
                                                    <option value="1">حذف همه ارسال نشده ها</option>
                                                    <option value="2">حذف همه صورتحسابهای دارای خطا</option>
                                                    <option value="3">ارسال دسته جمعی (تا سقف 100 صورتحساب)</option>
                                                    <option value="4">استعلام دسته جمعی</option>
                                                </select>
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block">
                                                    <a onClick={e => this.doTask(e)} className="btn btn-danger hand">اجرا</a>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ صورتحسابی یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col"><span className="sub-text text-center">ردیف</span></div>
                                            <div className="nk-tb-col"><span className="sub-text text-center">الگو</span></div>
                                            <div className="nk-tb-col"><span className="sub-text text-center">موضوع</span></div>
                                            <div className="nk-tb-col"><span className="sub-text text-center">نوع</span></div>
                                            <div className="nk-tb-col"><span className="sub-text text-center">روش تسویه</span></div>
                                            <div className="nk-tb-col tb-col-sm"><span className="sub-text text-center">سریال</span></div>
                                            <div className="nk-tb-col tb-col-sm"><span className="sub-text text-center">شماره فاکتور</span></div>
                                            <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center">شماره منحصربفرد مالیاتی</span></div>
                                            <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">شماره مالیاتی مرجع</span></div>
                                            <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">تاریخ</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-center">طرف حساب</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-center">مبلغ کل</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-center">وضعیت</span></div>
                                            <div className="nk-tb-col text-end" style={{ display: "flex", gap: "5px", padding: "5px" }}>
                                                <select defaultValue={this.state.currentConflictId} onChange={e => this.setState({ currentConflictId: e.target.value })} className="form-control">
                                                    <option value="">انتخاب مغایرت</option>
                                                    {this.state.conflicts.map(con => <option value={con.id}>{con.name}</option>)}
                                                </select>
                                                <a onClick={e => this.showConflicts()} className="hand text-primary"><i className="fa fa-list"></i></a>
                                            </div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className={"nk-tb-item " + (record.conflicts.includes(this.state.currentConflictId) ? "highlighted" : "")} key={record.id + "_" + this.state.currentConflictId}>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">ردیف: </span>
                                                    <span className="sub-text text-center">{this.genRowNumber(index)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">الگو: </span>
                                                    <span className="sub-text text-center">{record.inpString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">موضوع: </span>
                                                    <span className="sub-text text-center">{record.insString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">نوع: </span>
                                                    <span className="sub-text text-center">{record.intyString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">روش تسویه: </span>
                                                    <span className="sub-text text-center">{record.setmString}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-sm">
                                                    <span className="onlyMobile">سریال: </span>
                                                    <span className="sub-text text-center">{record.inno}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-sm">
                                                    <span className="onlyMobile">شماره فاکتور: </span>
                                                    <span className="sub-text text-center">{record.factorNo}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="onlyMobile">شماره منحصربفرد مالیاتی: </span>
                                                    <span className="sub-text text-center">{record.taxId}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="onlyMobile">شماره مالیاتی مرجع: </span>
                                                    <span className="sub-text text-center">{record.irtaxId}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="onlyMobile">تاریخ: </span>
                                                    <span className="sub-text text-center">{record.indatimPersian}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="onlyMobile">طرف حساب: </span>
                                                    <span className="sub-text text-center">{record.customerName}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="onlyMobile">مبلغ کل: </span>
                                                    <span className="sub-text text-center">{this.money(record.tbill)}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg text-center">
                                                    <span className="onlyMobile">وضعیت: </span>
                                                    {record.status === 1 && <span className="tb-status text-info">{record.statusString}</span>}
                                                    {record.status === 2 && <span className="tb-status text-warning">{record.statusString}</span>}
                                                    {record.status === 3 && <span className="tb-status text-danger">{record.statusString}</span>}
                                                    {record.status === 4 && <span className="tb-status text-success">{record.statusString}</span>}
                                                </div>
                                                <div className="nk-tb-col nk-tb-col-tools">
                                                    {!this.isBlank(this.state.currentConflictId) && <input type="checkbox" key={record.id + "_" + this.state.currentConflictId} defaultChecked={record.conflicts.includes(this.state.currentConflictId)} onChange={e => this.saveChecked(record.id, e.target.checked)} />}
                                                    <ul className="nk-tb-actions gx-1">
                                                        <li>
                                                            <div className="drodown">
                                                                <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                                                <div className="dropdown-menu dropdown-menu-end">
                                                                    <ul className="link-list-opt no-bdr">
                                                                        {this.getToolBars(record)}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,

                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                ,
                this.renderPopupComponent(),
                <Footer />
            ];

        return contents;
    }
}